import { Record } from "immutable";
import moment from "moment";

const defaults = {
    brand_id: undefined,
    created_on: undefined,
    modified_on: undefined,
    id: undefined,
    name: "",
    currency_code: undefined,
    active: undefined,
    status: undefined,
};

export class ShippingAccount extends Record(defaults) {
    declare brand_id: string;
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;
    declare id: string;
    declare name: string;
    declare active: string;
    declare status: string;

    constructor(args) {
        super({
            ...args,
            created_on: moment.utc(parseInt(args.created_on, 10)),
            modified_on: moment.utc(parseInt(args.modified_on, 10)),
        });
    }
}
